<template>
    <div class="orderPayChoose">
        <div class="payment">
            <p class="order_pay">订单金额 <span>￥{{order_money}}</span></p>
            <p class="count_down">请您在<span>{{minute}}</span>分<span>{{second}}</span>秒内支付成功，超时订单会自动取消</p>
        </div>
        <div class="choose_pay">
            <p>请选择支付方式</p>
            <!-- <div class="pay_ways_1">
                <p>微信支付</p>
                <p>推荐有微信账号的使用</p>
            </div>
            <div class="pay_ways_2">
                <p>支付宝支付</p>
                <p>推荐有微信账号的使用</p>
            </div>
            <div class="pay_ways_3">
                <p>中国银联支付</p>
                <p>推荐有微信账号的使用</p>
            </div> -->

            <div :class="{ pay_ways_1:val.code == 'weixinH5',pay_ways_2:val.code == 'alipaym',pay_ways_3:val.code != 'weixinH5' && val.code != 'alipaym',pitch_on_pay_way_class:modeOfPayment == val.code}" v-for="(val,key,index) in order_paymentList" :key="index" @click="pitchOn(val.code)">
                <p v-if="val.code == 'weixinH5'">微信支付</p>
                <p v-else-if="val.code == 'alipaym'">支付宝支付</p>
                <p v-else>中国银联支付</p>
                <p v-if="val.code == 'weixinH5'">推荐有微信账号的使用</p>
                <p v-else-if="val.code == 'alipaym'">推荐有支付宝账号的使用</p>
                <p v-else>推荐有银联账号的使用</p>
            </div>



        </div>
        <div class="confirm" @click="paymentFunc()">确认支付</div>
        <!-- <div class="weixinPayCodeContainer">
            <h3>请您在新打开的页面上完成付款</h3>
            <h4>付款完成前请不要关闭此窗口</h4>
            <h4>完成付款后请根据您的情况点击下面的按钮</h4>
            <div class="optionContainer">

            </div>
        </div> -->
    </div>
</template>

<script>
export default {
  name: "orderPayChoose",
  inject: ["showMsg"],
  data: function() {
    return {
      order_sn: "", //订单编号
      order_id: "", //订单ID
      order_info: "", //订单商品详情
      order_paymentList: "", //订单支付方式
      order_money: "", //订单总金额
      order_add_time: "", //订单在后台所创建的时间戳
      order_failure_time: "", //订单的失效时间的时间戳
      order_failure_long: 1800, //订单过多久失效，它是一个时间段，单位是秒(s)，默认是1800秒(s),30分钟
      minute: "", //订单取消定时器的“分”
      second: "", //订单取消定时器的“秒”
      timer_id: "", //定时器的编号(setInterval的返回值)
      modeOfPayment: "", //选择的支付方法
      userPayStatus: 0 //用户的支付状态userPayStatus,0=支付未成功；1=支付成功;默认情况下是0未支付状态
    };
  },
  created: function() {
    this.order_sn = this.$route.query.order_sn;
    this.order_id = this.$route.query.order_id;
    this.getPaymentListInfo();
    this.ajaxTimerToCheckOrderPayStatus();
    this.$store.commit("set_current", 6);
    this.$store.commit("set_title", "order");
  },
  computed: {
    weburl: function() {
      return this.$store.state.weburl;
    },
    hurl: function() {
      return this.$store.state.hurl;
    }
  },
  watch: {
    order_failure_long: function(n, o) {
      if (n <= 0) {
        clearInterval(this.timer_id);
      }
    }
  },
  methods: {
    // 订单支付的流程：
    // 1.到此页面之后，首先要获取可以支付的方式，getPaymentListInfo()方法。获取到支付的方式之后，渲染到页面上以供用户选择。
    // 2.用户要选择付款的方式，只有用户选择过付款方式，才允许用户点击“确认支付”按钮进行下一步操作
    // 3.当用户选择过付款方式后，点击了“确认支付”，这时候要触发一个轮询的方法，这个方法要定时的去向服务器发送请求，来获取这个订单是否支付成功。
    // 4.支付方法。
    // 5.支付成功后，会跳转到一个出票页面，这个页面显示正在出票（这是一个过度页面，过3秒左右会跳转到最后的出票结果页面）
    // ===========================================

    // 检查是否支付成功的轮询方法
    ajaxTimerToCheckOrderPayStatus: function() {
      let stopNum = setInterval(() => {
        this.$http({
          xhrFields: {
            withCredentials: true
          },
          crossDomain: true,
          method: "post",
          url: this.weburl + this.hurl + "/Api/check_order_pay_status",
          dataType: "json",
          data: {
            order_id: this.$route.query.order_id
          }
        })
          .then(res => {
            // console.log(res.data);
            if (res.data.result.pay_status == 1) {
              this.userPayStatus = 1;
              clearInterval(stopNum);
              this.$router.push({
                path: "/drawABill",
                query: { order_id: this.order_id, order_sn: this.order_sn,order_type:this.$route.query.order_type }
              });
            } else {
              // this.showMsg("支付失败，稍后再试");
            }
          })
          .catch(err => {
            // this.showMsg("网络错误，请稍后再试");
          });
      }, 1000);
    },
    getPaymentListInfo: function() {
      this.$http({
        xhrFields: {
          withCredentials: true
        },
        crossDomain: true,
        method: "post",
        url: this.weburl + this.hurl + "/Cart/paymentList",
        dataType: "json",
        data: {
          order_sn: this.order_sn,
          order_id: this.order_id,
          scene: 1
        }
      })
        .then(res => {
          if (res.data.status === 1) {
            this.order_info = res.data.result.order;
            this.order_paymentList = res.data.result.paymentList;
            this.order_money = res.data.result.order.order_amount;
            this.order_add_time = res.data.result.order.add_time;
            this.order_failure_time =
              this.order_failure_long + res.data.result.order.add_time;
            this.closeOrderTimer(this.order_failure_long);
          }
        })
        .catch(() => {
          this.showMsg(this.$t("error_msg"));
        });
    },
    // 订单超时取消的定时器
    closeOrderTimer: function(time) {
      this.minute = time / 60;
      this.second = "00";
      this.timer_id = setInterval(() => {
        if (time <= 0) {
          this.showMsg("订单超时");
        } else {
          time -= 1;
          this.order_failure_long = time;
          this.minute = Math.floor(time / 60);
          this.second = time % 60;
          if (this.second == 0) {
            this.second = "00";
          } else if (this.second < 10) {
            this.second = "0" + this.second;
          } else {
            this.second = this.second;
          }

          if (this.minute == 0) {
            this.minute = "00";
          } else if (this.minute < 10) {
            this.minute = "0" + this.minute;
          } else {
            this.minute = this.minute;
          }
        }
      }, 1000);
    },
    pitchOn: function(val) {
      this.modeOfPayment = val;
    },
    paymentFunc: function() {
      
      // if(true){
      //     this.showMsg("移动端暂不支持支付");
      //     return false;
      // }
      if (!this.modeOfPayment) {
        this.showMsg("请先选择支付方式");
        return false;
      }
      // 判断用户选择的是哪种支付方式，因为微信支付和支付宝与银联支付的方式是不一样的
      if (this.modeOfPayment == "weixinH5" || this.modeOfPayment == "alipaym" || this.modeOfPayment == "unionpay") {
        window.location.href =
          this.weburl +
          "Mobile/Payment/getCode/order_id/" +
          this.order_id +
          "/pay_code/" +
          this.modeOfPayment;
      }
    }
  }
};
</script>

<style scoped lang="less">
@import "../../assets/less/common.less";

.orderPayChoose {
  width: @width;
  font-size: @font;
  .payment,
  .choose_pay {
    background: #fff;
  }
  .payment {
    .border-bottom(10px, @bg);

    p {
      line-height: 50px;
      height: 50px;
      padding: 0 0.3rem;
      .border-bottom;
      &.order_pay {
        color: @word;
        span {
          float: right;
          color: #f12838;
        }
      }
      &.count_down {
        border-bottom: none;
        span {
          color: @brick_red;
          font-size: @font + 0.1;
        }
      }
    }
  }
  .choose_pay {
    /*margin-bottom: 30px ;*/
    & > p,
    & > div {
      .border-bottom;
    }
    & > p {
      padding: 0 0.5rem;
      line-height: 35px;
    }
    & > div {
      height: 55px;
      background-size: 238px auto;
      position: relative;
      padding: 0.5rem 3.6rem;
      .box-sizing;
      cursor: pointer;
      & > p:last-child {
          padding-top: 0.35rem;
        font-size: @font - 0.2;
        color: @word;
      }
      &.pay_ways_1:before,
      &.pay_ways_2:before,
      &.pay_ways_3:before,
      &.pay_ways_1:after,
      &.pay_ways_2:after,
      &.pay_ways_3:after {
        content: "";
        top: 5px;
        background-image: url("@{sprite}");
        background-repeat: no-repeat;
        background-position-y: 0;
        background-size: 238px auto;
        height: @width;
      }
      &.pay_ways_1:before,
      &.pay_ways_2:before,
      &.pay_ways_3:before {
        width: 38px;
        left: 0.5rem;
      }
      &.pay_ways_1:after,
      &.pay_ways_2:after,
      &.pay_ways_3:after {
        width: 19px;
        right: 0.5rem;
        background-position-x: -55px;
      }
      &.pay_ways_1:before {
        background-position-x: -74px;
      }
      &.pay_ways_2:before {
        background-position-x: -114px;
      }
      &.pay_ways_3:before {
        background-position-x: -154px;
      }
    }
  }
  .confirm {
    .btn;
    .width;
  }
}

.pitch_on_pay_way_class {
  background-color: wheat;
}

.weixinPayCodeContainer {
  width: 80vw;
  height: 30vh;
  position: fixed;
  left: 10vw;
  top: 20vh;
  background-color: pink;
  z-index: 100;
  border-radius: 10px;
}
.weixinPayCodeContainer h3 {
  text-align: center;
  margin-top: 10px;
  font-size: 18px;
  font-weight: 550;
  color: #966565;
}
.weixinPayCodeContainer h4 {
  font-size: 14px;
  margin-top: 5px;
  text-align: center;
  color: #9898a5;
}
.optionContainer {
  width: 80%;
  height: 10vh;
  // border:
}
</style>
